<template>
  <div class="container-size bg-success">
    <div class="s-card">
      <div class="text-center">
        <img src="/img/other/success.png" style="width: 100%;" />
      </div>

      <div class="text-center font-weight-bold mt-10">
        <p style="font-size: 24px; max-width: 410px; margin: auto;">
          {{ $t('successRequestSyllabus.title') }}
        </p>
      </div>

      <div class="text-center mt-5 mb-10" v-html="$t('successRequestSyllabus.description')"></div>

      <div class="text-center mt-5 d-flex" style="justify-content: center;">
        <Button :name="$t('successRequestSyllabus.button')" @click="sendToWa" width="270px" height="47px" />
      </div>

      <div class="text-center mt-10 mb-2">
        <span style="font-size: 1rem">{{ $t('successRequestSyllabus.contactInfo') }}</span>
      </div>

      <div style="margin: 12px auto; width: 250px;justify-content: center;">
        <div class="d-flex align-center">
            <img src="/img/other/ic_phone.png" style="width: 24px" />
            <span class="ml-3" style="font-weight: 600;">{{ $t('successRequestSyllabus.whatsappValue') }}</span>
        </div>
        <div class="d-flex align-center mt-2">
            <img src="/img/other/ic_email.png" style="width: 24px" />
            <span class="ml-3" style="font-weight: 600;">{{ $t('successRequestSyllabus.emailValue') }}</span>
        </div>
      </div>

      <!-- <table style="text-align: center;" v-else>
        <tr>
          <th style="width: 100px;">{{ $t('successRequestSyllabus.emailLabel') }}</th>
          
        </tr>
        <tr>
          <th>{{ $t('successRequestSyllabus.whatsappLabel') }}</th>
          <td>: <b>{{ $t('successRequestSyllabus.whatsappValue') }}</b></td>
        </tr>
      </table> -->
    </div>
  </div>
</template>

<script>
import Button from '../../components/others/Button.vue';
export default {
  components: {
    Button
  },
  data() {
    return {
      mobileView: false
    };
  },
  methods: {
    sendToWa() {
      window.open('https://api.whatsapp.com/send/?phone=6285110563798&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya', '_blank');
    },
  },
  mounted() {
    this.mobileView = window.innerWidth <= 990;
  }
};
</script>

<style scoped>
.s-card {
  padding: 40px 60px;
  width: 40%;
  margin: auto;
  background-color: white;
  border-radius: 36px;
}

.bg-success {
  background-color: rgb(243, 240, 240);
  padding: 30px 0;
}

@media screen and (max-width: 900px) {
  .s-card {
    width: 90%;
    padding: 30px 18px;
  }
}
</style>